import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import ls from 'localstorage-slim';
import { useTranslation } from 'react-i18next';

import DataContext from '../context/InvoiceData';

function Delivery() {
  const {
    step,
    setStep,
    documentType,
    documentTypeVersion,
    setDocumentType,
    setDocumentTypeVersion,
    setInvoiceSubType,
  } = useContext(DataContext);

  let navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const onChange = nextStep => {
    setStep(nextStep < 0 ? 0 : nextStep > 5 ? 5 : nextStep);
  };

  const handleClose = () => {
    setStep(0);
    setDocumentTypeVersion('');
    setDocumentType('');
    setInvoiceSubType('');
    ls.remove('id');
    navigate('../../document/new');
  };

  const handleContinue = () => {
    onChange(step + 1);
  };

  const handlePrevious = () => {
    onChange(step - 1);
  };

  return (
    <>
      <div className={`${i18n.language === 'ar' && 'text-end'} card border-0 shadow m-3`}>
        <div className='card-body body m-5'>
          <span className='p-2 fw-bold fs-5'>{`${documentType} | ${documentTypeVersion}`}</span>
          <div className={`${i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse'} my-3 p-2`}>
            <span
              className='subtitle text-decoration-underline pb-2'
              style={{ textUnderlineOffset: '10px' }}>
              <strong className='fs-5'>{t('stepper.delivery.title')}</strong>
            </span>
          </div>
          <div className='row mx-2 mb-3'>
            <div className={`${i18n.language === 'en' ? 'order-1' : 'order-2'} col`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-2`}>
                {t('stepper.delivery.approach')}
              </div>
              <div className='row px-2 mb-2'>
                <input type='text' dir={`${i18n.language === 'ar' && 'rtl'}`} className='py-3' />
              </div>
            </div>
            <div className={`${i18n.language === 'en' ? 'order-2' : 'order-1'} col`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-2`}>
                {t('stepper.delivery.packaging')}
              </div>
              <div className='row px-2 mb-2'>
                <input type='text' dir={`${i18n.language === 'ar' && 'rtl'}`} className='py-3' />
              </div>
            </div>
          </div>
          <div className='row mx-2 mb-4'>
            <div className={`${i18n.language === 'en' ? 'order-1' : 'order-5'} col-2`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.validity')}
              </div>
              <div className='row px-2 mb-1'>
                <input
                  type='text'
                  pattern='^[aA-zZ\d- ]+$'
                  title='Only letters and numbers.'
                  className='py-2'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
            <div className={`${i18n.language === 'en' ? 'order-2' : 'order-4'} col-4`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.port')}
              </div>
              <div className='row px-2 mb-1'>
                <input
                  type='text'
                  pattern='^[aA-zZ\d- ]+$'
                  title='Only letters and numbers.'
                  className='py-2'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
            <div className='col-3 order-3'>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.origin')}
              </div>
              <div className='row px-2 mb-1'>
                <input
                  type='text'
                  pattern='^[aA-zZ\d- ]+$'
                  title='Only letters and numbers.'
                  className='py-2'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
            <div className={`${i18n.language === 'en' ? 'order-4' : 'order-2'} col`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.gross')}
              </div>
              <div className='row px-2 mb-1'>
                <input
                  type='text'
                  pattern='^[\d.]+$'
                  title='Only numbers.'
                  className='py-2'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
            <div className={`${i18n.language === 'en' ? 'order-5' : 'order-1'} col`}>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.net')}
              </div>
              <div className='row px-2 mb-1'>
                <input
                  type='text'
                  pattern='^[\d.]+$'
                  title='Only numbers.'
                  className='py-2'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
          </div>
          <div className={`${i18n.language === 'ar' && 'justify-content-end'} row mx-2`}>
            <div className='col-6'>
              <div className={`row ${i18n.language === 'ar' && 'justify-content-end'} px-2 mb-1`}>
                {t('stepper.delivery.terms')}
              </div>
              <div className='row px-2'>
                <input
                  type='text'
                  pattern='^[aA-zZ\d-.% ]+$'
                  title='Only letters and numbers.'
                  className='py-4'
                  dir={`${i18n.language === 'ar' && 'rtl'}`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${
          i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse'
        } justify-content-evenly fixed-bottom py-3 bg-secondary bg-gradient bg-opacity-10`}>
        <button
          className={`${
            i18n.language === 'ar' && 'offset-6'
          } button text-center col-1 bg-white text-dark border border-1 border-dark`}
          onClick={handleClose}>
          {t('stepper.footer.close')}
        </button>
        <button
          className={`button text-center col-1 ${i18n.language === 'en' && 'offset-6'} ${
            step === 0 ? 'bg-secondary bg-gradient' : ''
          }`}
          onClick={handlePrevious}
          disabled={step === 0}>
          {t('stepper.footer.previous')}
        </button>
        <button className='button text-center col-1' onClick={handleContinue} disabled={step === 5}>
          {t('stepper.footer.continue')}
        </button>
      </div>
    </>
  );
}

export default Delivery;
